require('angular').module('oly.common')
    .service('MemoScrollService', ['$timeout', require('./memoscroll.service')]);



// WEBPACK FOOTER //
// ./src/olycommon/memoscroll/index.js